<div class="has-text-centered">
  <svg height="75" viewBox="0 0 23.585 23.585" width="75"
       xmlns="http://www.w3.org/2000/svg">
    <g data-name="Icon feather-download" id="Icon_feather-download"
       transform="translate(1.15 1.15)">
      <path d="M25.785,22.5v4.73A2.365,2.365,0,0,1,23.42,29.6H6.865A2.365,2.365,0,0,1,4.5,27.23V22.5" data-name="Pfad 101"
            fill="none"
            id="Pfad_101" stroke="#707070" stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.3" transform="translate(-4.5 -8.31)"/>
      <path d="M10.5,15l5.913,5.913L22.325,15" data-name="Pfad 102" fill="none"
            id="Pfad_102" stroke="#707070" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.3" transform="translate(-5.77 -6.722)"/>
      <path d="M18,18.69V4.5" data-name="Pfad 103" fill="none"
            id="Pfad_103" stroke="#707070" stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.3" transform="translate(-7.357 -4.5)"/>
    </g>
  </svg>
  <h2 class="title is-3">Wir benachrichtigen Sie.</h2>
  <p>Da der Download einige Zeit benötigen würde, bereiten wir alles im Hintergrund für Sie vor.</p>
  <p style="margin: 10px 0">Wenn der Download für Sie bereit steht, erhalten Sie eine E-Mail mit dem benötigten Link zum
    Download.</p>
  <p>Falls Sie vorab schon einmal nachschauen wollen, ob Ihnen schon ein Download zur Verfügung steht, klicken Sie <a
    routerLink="/batch-download">hier</a>.</p>
</div>
